module.exports = __webpack_public_path__ + "static/media/image_prd_1.a129ae49.png";